import React, { useEffect,useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';

import * as RestService from '../../services/eisRest';





  const FileModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    const [entityId, setEntityId] = useState();
    const [selectedRecord, setSelectedRecord] = useState();    
    const [file, setFile] = useState([]);
    const [currentFile, setCurrentFile] = useState();
    const [progress, setProgress] = useState(0);
    
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
  
    
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {   
      setSelectedRecord(props.selectedRecord);  
      RestService.callAnyApi('file/getFile?id='+props.selectedRecord, null)
      .then((data) => {
           setFile(data);})
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])


    const selectFile = (event) => {
     
        setCurrentFile(event.target.files[0])
        setProgress(0);        
    }
   
   

    const save = (url) => {
           
     
      RestService.callAnyApi(url,null)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));     
                          hideModal();                                                                 
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };


    const upload = () => {
      
      setProgress(0);
  
      RestService.uploadFile(currentFile, (event) => {
       
          setProgress(Math.round((100 * event.loaded) / event.total));
        
      },file.id,props.entityId,file.description)
        .then((response) => {
          console.log(response);
          toast.success(t('general.message.saveSucceed'));                                              
          hideModal();
        })
        .then((files) => {
          console.log(files);
        })
        .catch((err) => {
          setProgress(0);
          setCurrentFile(null);          
        });
    }

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=file&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }     
    }

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }
    

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        description: file.description || ""
      },
      validationSchema: Yup.object({
         
      }),
      onSubmit: (values) => {   
          file.description = values.description;      
          if(currentFile){
            upload();
          }else{
            save("file/updateFileDescription?id="+file.id+"&description="+file.description);
          }
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                 
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('file.label.file')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
          
                    <div className="row">

                          <div className="col-12">
                            <label className="btn btn-default p-0">
                              <input type="file" accept="*/*" onChange={selectFile} />
                            </label>
                          </div>

                    </div>
                    <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <label>{t('general.label.description')}</label>
                                <input type="text" className="form-control" placeholder="" {...formik.getFieldProps('description')} />
                              </div>
                              {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                            </div>                                                        
                    </div>
                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={entityId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default FileModal;